import { useId, useMemo } from 'react'
import useToggle from 'hooks/useToggle'
import type { PackageInclusionsDisclosure } from './packageInclusions'

/** One presentation-only disclosure state for all package cards belonging to a room. */
export default function useRoomPackageInclusionsDisclosure(): PackageInclusionsDisclosure {
  const contentId = useId()
  const { value: expanded, toggle: onToggle } = useToggle()
  return useMemo(() => ({ expanded, onToggle, contentId }), [contentId, expanded, onToggle])
}
